import { Button, ExpandCollapse, Modal, ModalContent, ModalFooterButtons, Text, TextField, Toggle } from "monday-ui-react-core";
import { useEffect, useState } from "react";
import MainService from "../../services/MainService";
import FormCreatePassword from "./FormCreatePassword";
import UrlConsts from "../../constants/UrlConstants";

interface Props {
    context: any;
}

const FormSettings: React.FC<Props> = ({ context }) => {
    const [showChangePass, setShowChangePass] = useState<boolean>(false);
    const [showCreatePass, setShowCreatePass] = useState<boolean>(false);
    const [oldPassword, setOldPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [statusChangePassword, setStatusChangePassword] = useState<any>();
    const [localUsingPassword, setLocalUsingPassword] = useState<boolean>(true);
    const [showResetPass, setShowResetPass] = useState<boolean>(false);


    useEffect(() => {
        async function init() {
            await setLocalUsingPassword(context.isUsingPassword);
        }
        init();
    }, []);

    async function handleOldPassword(event) {
        await setOldPassword(event);
        if (!event?.length) setStatusChangePassword({ status: '', text: '' });
    }

    async function handleNewPassword(event) {
        await setNewPassword(event);
        if (!event?.length) setStatusChangePassword({ status: '', text: '' });
    }

    async function handleChangePassword() {
        MainService.notice('Changing Password...', 'info');
        await setStatusChangePassword(null);
        if (!oldPassword?.length || !newPassword?.length) {
            if (!oldPassword?.length) await setStatusChangePassword({ oldPass: { status: 'error', text: 'Password invalid' } });
            if (!newPassword?.length) await setStatusChangePassword({ newPass: { status: 'error', text: 'Password invalid' } });
            MainService.notice('Something went wrong...', 'error');
            return;
        }

        const data = {
            accountId: context?.account?.id,
            boardId: context?.boardId,
            password: oldPassword,
            newPassword: newPassword
        }
        const rs = await MainService.post(data, UrlConsts.changePassword);
        const reset = rs?.data;
        if (reset?.status) {
            setShowChangePass(false);
            setOldPassword('');
            setNewPassword('');
            MainService.removeToken();
            MainService.notice('Password Changed Successfully!!!');
        } else {
            if (reset?.message === 'Incorrect old password')
                setStatusChangePassword({ oldPass: { status: 'error', text: 'Incorrect old password' } });
            MainService.notice('Something went wrong...', 'error');
        }
    }

    async function handleUsingPassword(event) {
        MainService.notice('Saving password settings...');
        const data = {
            accountId: context?.account?.id,
            boardId: context?.boardId,
            usingPassword: event
        }
        const rs = await MainService.post(data, UrlConsts.setNotUsingPassword);
        if (rs) {
            MainService.notice('Save password setting successfully');
            context.isUsingPassword = event;
            await setLocalUsingPassword(event);
        } else {
            MainService.notice('Something went wrong...', 'error');
            await setLocalUsingPassword(!event);
        }
    }

    const handleCreatePassComplete = async () => {
        setShowCreatePass(false);
        context.isUsingPassword = true;
        context.passCreated = true;
    };
    async function handleSwitchView(event) {
        MainService.notice('Saving view setting...');
        const data = {
            accountId: context?.account?.id,
            boardId: context?.boardId,
            viewMode: event
        }
        const rs = await MainService.post(data, UrlConsts.viewMode);
        if (rs?.data) {
            MainService.notice('Save view setting successfully');
            context.viewMode = event;
        } else {
            MainService.notice('Something went wrong...', 'error');
        }
    }

    async function handleGreyDefault(event) {
        MainService.notice('Saving grey default monday status setting...');
        const data = {
            accountId: context?.account?.id,
            boardId: context?.boardId,
            greyDefault: event
        }
        const rs = await MainService.post(data, UrlConsts.greyDefault);
        if (rs) {
            MainService.notice('Save grey default monday status successfully');
            context.greyDefault = event;
        } else {
            MainService.notice('Something went wrong...', 'error');
        }
    }

    async function handleRequestResetPassword() {
        MainService.notice('Sending request...', 'info');
        const reset = await MainService.requestResetPassword(context, context?.owners);
        if (reset) MainService.notice('Sent');
        else MainService.notice('Something went wrong...', 'error');
        await setShowResetPass(false);
        setOldPassword('');
        setNewPassword('');
    }

    function handleCloseChangePassword() {
        setOldPassword('');
        setNewPassword('');
        setShowChangePass(false);
    }

    return (
        <div className="w-4/5 mx-auto">
            <ExpandCollapse title="Password" defaultOpenState className="mb-8">
                <div>
                    <Text type={Text.types.TEXT2} color={Text.colors.PRIMARY} className="font-bold">
                        Do you want to use a password?
                    </Text>
                </div>
                <div className="mt-2">
                    <Text type={Text.types.TEXT2} color={Text.colors.PRIMARY} className="font-thin italic ml-2" ellipsis={false}>
                        Disable: When accessing this board view, you won't need a password.<br />
                        Enable: You need to create a password, and when accessing this board view, you'll need to enter the previously created password.
                    </Text>
                </div>
                {/* <Flex justify={Flex.justify.SPACE_BETWEEN} className='mt-4'> */}
                <div className='mt-4 text-left ml-4'>
                    <Toggle disabled={!context.isOwner} isDefaultSelected={context.isUsingPassword} offOverrideText='Disable' onOverrideText='Enable' onChange={(event) => { handleUsingPassword(event) }} />
                    <div className="mt-4 flex">
                        {
                            localUsingPassword && !context.passCreated && (
                                <>
                                    <Button onClick={() => { setShowCreatePass(true); }}>Create Password</Button>
                                    <div>
                                        <Modal
                                            show={showCreatePass}
                                            onClose={() => { setShowCreatePass(false); }}
                                            title=" "
                                        >
                                            <ModalContent>
                                                <div className='mt-4'>
                                                    <FormCreatePassword createPassComplete={handleCreatePassComplete} context={context}></FormCreatePassword>
                                                </div>
                                            </ModalContent>
                                        </Modal>
                                    </div>
                                </>
                            )
                        }
                        {
                            (localUsingPassword && context.passCreated) && (<>
                                {
                                    context.isOwner && (
                                        <>
                                            <Button onClick={() => { setShowChangePass(true); }}>Change Password</Button>
                                            <div>
                                                <Modal
                                                    show={showChangePass}
                                                    onClose={handleCloseChangePassword}
                                                    title=" "
                                                >
                                                    <ModalContent>
                                                        <TextField
                                                            placeholder="Old Password"
                                                            title="Old password"
                                                            type={TextField.types.PASSWORD}
                                                            wrapperClassName="monday-storybook-text-field_size"
                                                            value={oldPassword}
                                                            onChange={(event: string) => handleOldPassword(event)}
                                                            validation={{
                                                                status: statusChangePassword?.oldPass?.status,
                                                                text: statusChangePassword?.oldPass?.text
                                                            }}
                                                        />
                                                        <div className="mt-3">
                                                            <TextField
                                                                placeholder="New Password"
                                                                title="New password"
                                                                type={TextField.types.PASSWORD}
                                                                wrapperClassName="monday-storybook-text-field_size"
                                                                value={newPassword}
                                                                onChange={(event: string) => handleNewPassword(event)}
                                                                validation={{
                                                                    status: statusChangePassword?.newPass?.status,
                                                                    text: statusChangePassword?.newPass?.text
                                                                }}
                                                            />
                                                        </div>
                                                    </ModalContent>
                                                    <ModalFooterButtons
                                                        onPrimaryButtonClick={handleChangePassword}
                                                        onSecondaryButtonClick={handleCloseChangePassword}
                                                        primaryButtonText="Confirm"
                                                        secondaryButtonText="Cancel"
                                                    />
                                                </Modal>
                                            </div>
                                        </>
                                    )
                                }

                                <Button onClick={() => { setShowResetPass(true); }} className="ml-5">Reset Password</Button>

                                <Modal
                                    show={showResetPass}
                                    onClose={() => { setShowResetPass(false); }}
                                    title="Request to reset password?"
                                >
                                    <ModalContent>
                                        <p className="mt-5">A password reset request will be sent to the board owner. Please contact them to receive the new password.</p>
                                        <br />
                                        <br />
                                    </ModalContent>
                                    <ModalFooterButtons
                                        onPrimaryButtonClick={handleRequestResetPassword}
                                        onSecondaryButtonClick={() => { setShowResetPass(false); }}
                                        primaryButtonText="Confirm"
                                        secondaryButtonText="Cancel"
                                    />
                                </Modal>
                            </>)
                        }
                    </div>
                </div>
                {/* </Flex> */}
            </ExpandCollapse>
            <ExpandCollapse title={'View'} defaultOpenState className="mb-8">
                <Text type={Text.types.TEXT2} color={Text.colors.PRIMARY} className="font-thin italic" ellipsis={false}>
                    In the default view, columns are displayed horizontally and groups are shown vertically.
                </Text>
                <Text type={Text.types.TEXT2} color={Text.colors.PRIMARY} className="font-thin italic mb-4" ellipsis={false}>
                    In the inverted view, this arrangement is reversed.
                </Text>
                <div className="ml-4">
                    <Toggle isDefaultSelected={context.viewMode} offOverrideText='Default' onOverrideText='Inverted' onChange={(event) => { handleSwitchView(event) }} />
                </div>
                {/* <Button onClick={handleSwitchView} className='mr-6' disabled={saving || loadingColumn}>Switch View <i className="ml-1 fa-solid fa-right-left"></i></Button> */}

            </ExpandCollapse>
            <ExpandCollapse title={'Others'} defaultOpenState className="mb-8">
                <Text type={Text.types.TEXT2} color={Text.colors.PRIMARY} className="font-bold mb-2">
                    Treat Default Grey Status as Empty
                </Text>
                <Text type={Text.types.TEXT2} color={Text.colors.PRIMARY} className="font-thin italic ml-2" ellipsis={false}>
                    In the Status columns, you can decide whether the default grey status should be considered as empty.
                </Text>
                <Text type={Text.types.TEXT2} color={Text.colors.PRIMARY} className="font-thin italic mb-4 ml-3" ellipsis={false}>
                    For example, some users might use the grey status and label it as "Select." If you want to treat "Select" as an empty field regardless of the label, keep this option turned on.
                </Text>
                <div className="ml-4 mt-4">
                    <Toggle isDefaultSelected={context.greyDefault === null || context.greyDefault === true ? true : false} offOverrideText='Off' onOverrideText='On' onChange={(event) => { handleGreyDefault(event) }} />
                </div>
                {/* <Button onClick={handleSwitchView} className='mr-6' disabled={saving || loadingColumn}>Switch View <i className="ml-1 fa-solid fa-right-left"></i></Button> */}

            </ExpandCollapse>
            {/* {
                isChangeUsingPassword && (
                    <div className='mt-20'>
                        <Button onClick={handleSaveSetting} className="text-center">Save Settings</Button>
                    </div>
                )
            } */}
        </div>
    )
}


export default FormSettings;